import Vue from "vue";
import Vuex from "vuex";
import loading from "./modules/loading";
import auth from "./modules/auth";
import transactions from "./modules/transactions";
import alert from "./modules/alert";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    loading,
    auth,
    transactions,
    alert
  },
  strict: debug
});
